import Sound from '@/webgl/audio/Sound'
import Signal from '@/webgl/core/Signal'

export type SoundTime = {
  currentTime: number
  duration: number
  bufferTime: number
  bufferDuration: number
}

export default class SoundObserver {
  private _timeUpdateInterval: number
  private sound: Sound

  onTimeUpdate: Signal<SoundTime> = new Signal<SoundTime>()
  onEnded: Signal<void> = new Signal<void>()

  observe(sound: Sound) {
    this.onTimeUpdate.release()
    this.sound = sound
    this.sound.onEnded.on(this._onEnded)
    this._startTimeUpdates()
  }

  _onEnded = () => {
    this.onEnded.emit()
    this.dispose()
  }

  dispose = () => {
    this._stopTimeUpdates()
    this.onEnded.release()
    this.onTimeUpdate.release()
  }

  private _startTimeUpdates() {
    const update = () => {
      if (this.sound.disposed) return

      this.onTimeUpdate.emit({
        currentTime: this.sound.getCurrentTime(),
        duration: this.sound.duration,
        bufferTime: this.sound.start + this.sound.getCurrentTime(),
        bufferDuration: this.sound.node.buffer.duration,
      })

      this._timeUpdateInterval = requestAnimationFrame(update)
    }

    update()
  }

  private _stopTimeUpdates() {
    if (this._timeUpdateInterval) {
      cancelAnimationFrame(this._timeUpdateInterval)
      this._timeUpdateInterval = null
    }
  }
}
